export const isEmpty = (obj: unknown): boolean =>
  [Object, Array, String].includes(
    ((obj ?? {}) as object).constructor as ArrayConstructor | ObjectConstructor | StringConstructor
  ) && !Object.entries(obj ?? {}).length
